package com.xtream.ui.ui.widget


import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.gestures.BringIntoViewSpec
import androidx.compose.foundation.gestures.LocalBringIntoViewSpec
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.MutableIntState
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.LayoutDirection

@OptIn(ExperimentalFoundationApi::class)
@Composable
fun FocusPositioner(
    parentFraction: Float = 0.3f,
    childFraction: Float = 0f,
    content: @Composable () -> Unit,
) {
    val layoutDirection = LocalLayoutDirection.current

    val bringIntoViewSpec = remember(parentFraction, childFraction, layoutDirection) {
        object : BringIntoViewSpec {

            override fun calculateScrollDistance(
                offset: Float,
                size: Float,
                containerSize: Float
            ): Float {
                val childSmallerThanParent = size <= containerSize

                // In RTL, the leading edge fraction is mirrored:
                // LTR: item should land at (parentFraction) from the left
                // RTL: item should land at (1 - parentFraction) from the left,
                //      i.e. parentFraction from the right
                val effectiveParentFraction = when (layoutDirection) {
                    LayoutDirection.Rtl -> 1f - parentFraction
                    else -> parentFraction
                }

                val effectiveChildFraction = when (layoutDirection) {
                    LayoutDirection.Rtl -> 1f - childFraction
                    else -> childFraction
                }

                val initialTargetForLeadingEdge =
                    effectiveParentFraction * containerSize - (effectiveChildFraction * size)

                val spaceAvailableToShowItem = containerSize - initialTargetForLeadingEdge

                val targetForLeadingEdge =
                    if (childSmallerThanParent && spaceAvailableToShowItem < size) {
                        containerSize - size
                    } else {
                        initialTargetForLeadingEdge
                    }

                return offset - targetForLeadingEdge
            }
        }
    }

    CompositionLocalProvider(
        LocalBringIntoViewSpec provides bringIntoViewSpec,
        content = content,
    )
}